import { useState } from 'react';
import cn from '../../../../utils/cn';
import { GetFloatNumber } from '../../../../utils/NumberFormatter';
import { GetDate } from '../../../../utils/Show';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const [isTrActive, setIsTrActive] = useState(false);
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.invoiceId}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">{item?.gateway}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Gateway"
                    value={item?.gateway}
                    isCapitalize
                    className="sm:hidden"
                />
                <TableInfoCard name="Customer Name" value={item?.fullName} />

                <TableInfoCard name="Initiate Date" value={GetDate(item?.timeInitiate)} />
                <TableInfoCard name="Success Date" value={GetDate(item?.timeSuccess)} />
                <TableInfoCard name="Currency" value={item?.currency} />
                <TableInfoCard name="Amount" value={GetFloatNumber(item?.amount)} />
                <TableInfoCard
                    name="Status"
                    value={
                        item?.status ? (
                            <span className="text-success">{item?.status}</span>
                        ) : (
                            <span className="text-error">{item?.status}</span>
                        )
                    }
                    isCapitalize
                />
            </div>
        </div>
    );
}

function TransPageTableMobile({ data }) {
    return (
        <div className="transaction_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data?.transactions && data?.transactions?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.transactions?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default TransPageTableMobile;
